export default "__VITE_ASSET__CLNp6QbC__"